<template>
  <div v-if="data" class="enter-vin">
    <div class="container">
      <h1 class="uikit__h3" v-if="data.title != null">
        {{ data.title || componentData.title }}
      </h1>

      <div class="form-search">
        <form @submit.prevent="submitForm" class="form-search__form">
          <h3 class="form-search__subtitle" :v-if="messages.form.subtitle">
            {{ messages.form.subtitle }}
          </h3>
          <h3 class="form-search__subtitle" :v-if="data.subtitle">
            {{ data.subtitle }}
          </h3>

          <BaseInput
            @inputValue="getValue"
            ref="inputText"
            :placeholder="data.form.placeholder"
            toUpperCase
            mask="NNNNNNNNNNNNNNNNN"
            inputType="text"
            class="form-search__input"
          />

          <BaseBtn
            class="form-search__btn deactive"
            :type="'submit'"
            @click.native="vinEvnt"
          >
            {{ data.form.button.text }}
          </BaseBtn>

          <div class="form-search__desc" v-if="data.form.file">
            <a :href="data.form.file" class="form-search__link" target="_blank">
              {{ data.form.message }}
            </a>
          </div>

          <div class="form-search__desc" v-else-if="data.form.file == null">
            {{ data.form.message }}
          </div>
        </form>
      </div>

      <div class="enter-vin__description" v-html="data.content"></div>

      <div class="error-container" v-if="error" v-html="error"></div>
    </div>
  </div>
</template>

<script>
import BaseBtn from "./base/BaseBtn";
import BaseInput from "./base/BaseInput";
import axios from "axios";
import { config } from "../config";

export default {
  name: "enter_vin",
  components: {
    BaseBtn,
    BaseInput
  },
  props: {
    messages: {
      type: Object,
      required: true
    },
    message: {
      type: String
    },
    submit: {
      type: Object,
      // required: true,
      default: () => ({})
    },
    refreshDate: {
      type: Object
    },
    componentData: Object
  },
  data() {
    return {
      data: null,
      input: null,
      error: null,
      locale: null,
      getUrl: null,
      searchVal: null
    };
  },
  computed: {
    url() {
      return this.createUrl(`/check/${this.input}`);
    }
  },
  methods: {
    vinEvnt() {
      window.dataLayer.push({ event: "clickvin" });
    },
    getValue(e) {
      let searchBtn = document.querySelector(".form-search__btn");
      if (e.length >= 1) {
        searchBtn.classList.remove("deactive");
      } else {
        searchBtn.classList.add("deactive");
      }
      this.input = e;
      this.$emit("customWin", this.input);
    },
    submitForm() {
      let data = new FormData();

      this.axios.get(this.url, data).then(({ data }) => {
        if (data.componentName === "result") {
          // code for success
        } else {
          // for error
          window.dataLayer.push({ event: "novin" });
        }
        this.error = data.text;
        this.$emit("customEvent", data);
        this.data = data;
        this.$refs.inputText.value = "";
        let searchBtn = document.querySelector(".form-search__btn");
        searchBtn.classList.add("deactive");
      });
    },
    createUrl(arg) {
      const searchVal = window.location.search;
      return `${this.getUrl}${arg}${searchVal}`;
    }
  },

  created() {
    const lang = window.location.pathname;

    const url = lang.split("/");
    const locale = url[1];

    if (locale.length > 0) {
      this.getUrl = `${config.API}${lang}/vin`;
    } else {
      this.getUrl = `${config.API}/vin`;
    }

    if (!this.componentData) {
      axios.get(this.createUrl("")).then(res => {
        this.data = res.data;
      });
    } else {
      this.data = this.componentData;
    }
  }
};
</script>

<style lang="sass">
@import '../assets/sass/partials/_sass-components.sass'
.enter-vin
  // padding: 67px 0 110px
  padding: 0
  +res('mob')
    // padding: 34px 0
    padding: 0
    overflow: hidden


.enter-vin__description
  text-align: left
  p
    font-family: $text-font-book

.form-search
  margin-bottom: 60px

  &__subtitle
    font-family: $font-semibold
    font-size: 22px
    font-weight: 400
    line-height: 1.35
    color: $black
    margin-bottom: 40px
    +res('mob')
      font-size: 16px
      line-height: 1.64
      margin-bottom: 10px
  &__link
    font-family: $text-font-book
    font-size: 16px
    color: #282830

  &__input
    width: 320px
    margin-right: 20px
    margin-bottom: 0
    +res('mob')
      margin-bottom: 10px
      max-width: 100%
      // margin-right: 0
    .vin-label__input
      // border: 1px solid #6c7073
      font-family: $text-font-book
      font-size: 15px

  &__desc
    font-family: $text-font
    font-size: 13px
    line-height: 1.38
    color: $black
    margin-top: 20px

  &__btn
    pointer-events: auto
    &.deactive
      pointer-events: none
      opacity: .5
</style>
